import Parse from '../parse/index.js';

export default () => {
    return Parse.User.current();
};
